import React, { useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import { useAuth } from '../../../hooks/auth';
import { useOnlineStatus } from '../../../hooks/onlineStatus';
import getValidationErrors from '../../../utils/getValidationErrors';

import BackHeader from '../../../components/BackHeader';
import Input from '../../../components/Form/Input';
import Button from '../../../components/Button';
import Offline from '../../../components/OfflineMessage';

import { Divider } from '../../../components/Generic';
import { Container, Content } from './styles';

interface ProfileData {
  new_password: string;
  old_password: string;
}

const Profile: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const formRef = useRef<FormHandles>(null);

  const { addToast } = useToast();
  const { user } = useAuth();
  const history = useHistory();
  const isOnline = useOnlineStatus();

  const handleSubmit = useCallback(
    async (data: ProfileData) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          new_password: Yup.string().min(
            6,
            'A senha deve ter no mínimo 6 dígitos.',
          ),
          new_password_confirm: Yup.string().oneOf(
            [Yup.ref('new_password'), null],
            'As senhas devem corresponder.',
          ),
          old_password: Yup.string().required('Informe sua senha atual.'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.put('/perfil/atualizar', {
          nome: user.nome,
          email: user.email,
          senha: data.new_password,
          senha_antiga: data.old_password,
        });

        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'Sua senha foi atualizada.',
        });

        history.goBack();
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro!',
          description: err.response.data.message,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  return (
    <Container>
      <BackHeader title="Atualizar senha" />

      {!isOnline ? (
        <Offline />
      ) : (
        <Content>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Input label="Nova senha" name="new_password" type="password" />

            <Input
              label="Confirmar nova senha"
              name="new_password_confirm"
              type="password"
            />

            <Divider />

            <Input label="Senha atual" name="old_password" type="password" />

            <Button type="submit" isLoading={loading} style={{ marginTop: 24 }}>
              Salvar
            </Button>
          </Form>
        </Content>
      )}
    </Container>
  );
};

export default Profile;
